import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { pageRoute } from '@constants/routes'
import './Cta.module.scss'
import { constructPageLink } from '@helpers/LinkHelper'

const Cta = ({title, slug, image, anchorLink = false, slugOptions = {type: undefined, category: undefined}}) => {
  let hasOptions = false
  if (slugOptions.type || slugOptions.category) {
    hasOptions = true
  }
  const link = !anchorLink && hasOptions ? constructPageLink(slug, slugOptions.type, slugOptions.category, undefined) : pageRoute(slug)
  return (
    <div
      key={title}
      styleName={`categories-item`}
    >
      <div
        styleName='background'
        style={{ backgroundImage: `url(${image})` }}
      />
      <div styleName='fade' />
      <div styleName='content'>
        <h2 styleName='title'>{title}</h2>
      </div>
      {anchorLink
        ? <AnchorLink offset='60' href={slug} styleName='link'><span class='sr-only'>{title}</span></AnchorLink>
        : <Link to={link} styleName='link'><span class='sr-only'>{title}</span></Link> }
    </div>
  )
}

Cta.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  image: PropTypes.string,
  anchorLink: PropTypes.bool
}

export default Cta



// WEBPACK FOOTER //
// ./src/components/Cta/Cta.js